import React, { useState, useEffect } from 'react';
import useDocumentManager from '../../hooks/useDocumentManager';
import DocumentToolbar from './DocumentToolbar';

/**
 * Document editor component
 * Provides text editing, save, and export functionality
 * 
 * @returns {JSX.Element} - Rendered component
 */
function DocumentEditor() {
  const {
    activeDocument,
    updateDocument,
    saveDocument
  } = useDocumentManager();
  
  const [content, setContent] = useState('');
  
  // Update content when active document changes
  useEffect(() => {
    if (activeDocument) {
      setContent(activeDocument.content);
    } else {
      setContent('');
    }
  }, [activeDocument]);
  
  const handleContentChange = (e) => {
    const newContent = e.target.value;
    setContent(newContent);
    
    if (activeDocument) {
      updateDocument(activeDocument.id, {
        content: newContent,
        isDirty: true
      });
    }
  };
  
  const handleSave = () => {
    if (activeDocument) {
      saveDocument(activeDocument.id);
    }
  };
  
  const handleTitleChange = (newTitle) => {
    if (activeDocument) {
      updateDocument(activeDocument.id, {
        title: newTitle,
        isDirty: true
      });
    }
  };
  
  const handleUndo = () => {
    console.log('Undo action - to be implemented in Chunk 5');
  };
  
  const handleRedo = () => {
    console.log('Redo action - to be implemented in Chunk 5');
  };
  
  const handleExportToOscar = () => {
    console.log('Export to Oscar (TXT) - to be implemented in Chunk 4');
  };
  
  const handleExportToWord = () => {
    console.log('Export to Word (DOCX) - to be implemented in Chunk 4');
  };
  
  return (
    <div style={{ 
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      border: activeDocument 
        ? `1px solid ${activeDocument.colorCode}` 
        : '1px solid #e0e0e0',
      borderRadius: '4px',
      overflow: 'hidden',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
    }}>
      <DocumentToolbar 
        document={activeDocument}
        onSave={handleSave}
        onUndo={handleUndo}
        onRedo={handleRedo}
        onTitleChange={handleTitleChange}
        onExportToOscar={handleExportToOscar}
        onExportToWord={handleExportToWord}
        canUndo={false}
        canRedo={false}
      />
      
      <div style={{ 
        flex: 1, 
        overflow: 'hidden',
        display: 'flex',
        backgroundColor: '#fff'
      }}>
        {activeDocument ? (
          <textarea
            value={content}
            onChange={handleContentChange}
            style={{
              flex: 1,
              border: 'none',
              padding: '16px',
              resize: 'none',
              fontSize: '16px',
              lineHeight: 1.5,
              fontFamily: 'monospace',
              outline: 'none'
            }}
            placeholder="Enter your document content here..."
          />
        ) : (
          <div style={{ 
            flex: 1, 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            color: '#888',
            fontSize: '16px',
            backgroundColor: '#f9f9f9'
          }}>
            <div style={{ textAlign: 'center' }}>
              <p>No document selected</p>
              <p>Open a document from the sidebar or create a new one.</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default DocumentEditor;
